/** @jsx jsx */
import { gql } from '@apollo/client';
import { P } from '@bottlebooks/gatsby-design-system';
import { Trans } from '@lingui/macro';
import { graphql } from 'gatsby';
import React from 'react';
import { jsx } from 'theme-ui';
import Section from '../Section/Section';

export default function ProductVineyard({ product, ...rest }) {
  if (!product?.vineyardInformation && !product?.vineyard) return null;
  // If only the vineyard is set:  Display vineyard in the content, as large text.
  // If the vineyardInformation is set, display it in the content
  return (
    <Section
      title={
        <React.Fragment>
          <Trans>Vineyard</Trans>
          {product.vineyard && product.vineyardInformation && (
            <React.Fragment>: {product.vineyard}</React.Fragment>
          )}
        </React.Fragment>
      }
      {...rest}
    >
      {product.vineyardInformation ? (
        product.vineyardInformation.split('\n\n').map((p, index) => (
          <P key={index} variant="large">
            {p}
          </P>
        ))
      ) : (
        <P variant="title">{product.vineyard}</P>
      )}
    </Section>
  );
}

export const fragment = graphql`
  fragment ProductVineyard on Product {
    vineyard
    vineyardInformation
  }
`;

export const ProductVineyardFragment = gql`
  fragment ProductVineyard on Product {
    vineyard
    vineyardInformation
  }
`;
